const axios = require('axios');

/*
  Function to submit form data.
*/
const submitEnterpriseForm = (options = {}) => {
  const {
    locale,
    customFormId,
    formData,
    host,
  } = options;

  if (!customFormId) {
    throw new Error('must have custom form id defined');
  }

  return axios.post(
    `${host}/${locale}/native_forms/custom_forms/${customFormId}/b2b_forms`,
    formData,
    {
      headers: {
        'Content-type': 'application/json',
        'X-CSRF-Token': formData.authenticity_token,
      },
      withCredentials: true,
    },
  );
};

export default submitEnterpriseForm;
